import React, { useState, useRef, useEffect } from "react";
import axiosInstance from "../../interceptor/axiosInstance";

const SearchBarAssign = ({ setUsers, setLoading, fetchData, searchTerm, onSearchChange, pageSize }) => {
  const [localSearchText, setLocalSearchText] = useState(searchTerm || "");
  const searchTimeoutRef = useRef(null);
  const abortControllerRef = useRef(null);

  // Sync local search with parent search term
  useEffect(() => {
    setLocalSearchText(searchTerm);
  }, [searchTerm]);

  const handleSearch = async (text) => {
    setLocalSearchText(text);
    onSearchChange(text);

    // Clear existing timeout
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    // Cancel previous request
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    // Debounce search
    searchTimeoutRef.current = setTimeout(() => {
      if (text.length > 2) {
        // Create new abort controller
        abortControllerRef.current = new AbortController();
        
        setLoading(true);
        axiosInstance
          .get(`accounts/users/?page=1&page_size=${pageSize}&username=${text}`, {
            signal: abortControllerRef.current.signal
          })
          .then((response) => {
            const { results } = response.data.data;
            setUsers(results || []);
          })
          .catch((error) => {
            if (error.name !== 'CanceledError') {
            }
          })
          .finally(() => {
            setLoading(false);
          });
      } else if (text.length === 0) {
        fetchData(1, '', pageSize);
      }
    }, 500);
  };

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  return (
    <div className="assign-search-wrapper">
      <input
        placeholder="Search by Name, Email, Registration Number and Employee Id"
        value={localSearchText}
        onChange={(e) => handleSearch(e.target.value)}
        className="assign-search-input"
      />
      {localSearchText && (
        <button 
          className="assign-search-clear"
          onClick={() => handleSearch('')}
          aria-label="Clear search"
        >
          ×
        </button>
      )}
    </div>
  );
};

export default SearchBarAssign;
